import { asNodeIDArray } from "@hex-insights/app-modules";
import { TypeFilterObject, valuesTypeFilter } from "@hex-insights/core";
import { AcademicSubject, ClassYear, Employee, EmployeeRole } from "../../../Utilities";

export type StandardFilterFormValues = {
	statusEQ: "Current" | "Future" | "Former" | null;
	roleEQ: Employee["role"] | null;
	academicSubjectIDsIn: AcademicSubject["id"][];
	classYearIDsIn: ClassYear["id"][];
};

export const initialStandardFilters: StandardFilterFormValues = {
	statusEQ: null,
	roleEQ: null,
	academicSubjectIDsIn: [],
	classYearIDsIn: [],
};

export const standardFiltersTypeFilterObject: TypeFilterObject<StandardFilterFormValues> = {
	statusEQ: valuesTypeFilter(["Current", "Future", "Former", null], null),
	roleEQ: valuesTypeFilter(
		[
			EmployeeRole.AcademicAdmin,
			EmployeeRole.FinancialAdmin,
			EmployeeRole.GeneralAdmin,
			EmployeeRole.GeneralStaff,
			EmployeeRole.PrincipalAdmin,
			EmployeeRole.Teacher,
			null,
		],
		null,
	),
	academicSubjectIDsIn: asNodeIDArray,
	classYearIDsIn: asNodeIDArray,
};
